import { cannot } from '@/app/helpers'
import { CampaignTemplateType, type SubscriptionStats, type SubscriptionStatus } from '@/app/module/campaigns/types'

export const canResume = (type: CampaignTemplateType): boolean => {
  switch (type) {
    case CampaignTemplateType.WhatsAppSurvey:
    case CampaignTemplateType.VoiceSurvey:
    case CampaignTemplateType.SMSSurvey:
      return true
    case CampaignTemplateType.CATI:
    case CampaignTemplateType.Drip:
    case CampaignTemplateType.Reminder:
    case CampaignTemplateType.SMSBlast:
    case CampaignTemplateType.VoiceBlast:
    case CampaignTemplateType.Chatbot:
      return false
    default:
      return cannot(type)
  }
}

export const getSubscriptionStatus = (stats?: SubscriptionStats): SubscriptionStatus => {
  if (!stats?.totalCount) {
    return 'non-subscribed'
  }
  return stats?.activeId ? 'subscribed' : 'done'
}
